import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Text from '../components/common/Text';
import TextSmall from '../components/common/TextSmall';
import Footer from '../components/common/Footer';
import HorizontalDivider from '../components/common/HorizontalDivider';
import Button from '../components/common/Button';
import { reset } from '../redux/reducer/slice';

const DirectoryPage = () => {
  const navigate = useNavigate();
  const hotelInformation = useSelector((state) => state.app.hotelInformation);
  const {
    yourBillPageUrl,
    tippingPageUrl,
    invoicesPageUrl,
  } = useSelector((state) => state.app.urls);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(reset());
  }, [dispatch]);

  return (
    <main className="flex min-h-screen flex-col gap-16 py-16">
      <section>
        <h1 className="mb-12 mt-6 max-w-sm font-nunito  text-7xl">
          <span>How may we </span>
          <span style={{ color: hotelInformation.color || '#EE7B30' }}>
            help?
          </span>
        </h1>
        <Text>
          Please choose an option below. You may always come back to this page
          by re-scanning the QR Code.
        </Text>
      </section>
      <div className="flex flex-col gap-6">
        <Button
          variant="primary"
          text="Pay your bill"
          type="button"
          extraPadding
          onClick={() => {
            navigate(yourBillPageUrl);
          }}
        />
        <Button
          variant="primary"
          text="Leave a tip"
          type="button"
          onClick={() => {
            navigate(tippingPageUrl);
          }}
        />
        <Button
          disabled
          variant="primary"
          text="Checkout my room*"
          type="button"
          onClick={() => {
            navigate(invoicesPageUrl);
          }}
        />
      </div>
      <div className="mt-auto">
        <HorizontalDivider />
        <TextSmall>
          * A room checkout can only be performed once the entire bill has been
          settled. Please pay all items first in order to continue.
        </TextSmall>
      </div>
      <div className="mt-auto">
        <Footer />
      </div>
    </main>
  );
};

export default DirectoryPage;
